import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { TitleProps } from '../types';

const Title = (props: TitleProps) => {
  const { heading1, heading2 } = props.heading;
  return (
    <h3
      className={ivclass(
        'iv-pt-30 sm:iv-pt-40 lg:iv-pt-25',
        'sm:iv-text-center lg:iv-text-center xl:iv-text-center',
        'sm:iv-m-heading-4xs md:iv-m-heading-2xs lg:iv-m-heading-2xs xl:iv-m-heading-s',
        'sm:iv-text-heading-4xs md:iv-text-heading-2xs lg:iv-text-heading-2xs xl:iv-text-heading-s',
        'iv-font-bold',
      )}
    >
      <span className={ivclass('iv-inline-block lg:iv-block xl:iv-block')}>
        {heading1}
      </span>
      {heading2 ? ` ${heading2}` : ''}
    </h3>
  );
};

export default Title;
